import AppThemeFields, { colorModeLabel } from './AppThemeFields';

export { colorModeLabel };
export default AppThemeFields;
